var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FMD',{attrs:{"declarations":_vm.section.declarations,"product-id":_vm.productId,"read-only":true}})}
var staticRenderFns = []

export { render, staticRenderFns }